class WhoopeaMobileMenu {
  constructor() {
    this.drawer = document.querySelector('header-drawer');
    if (!this.drawer) return;

    this.mainDetails = this.drawer.querySelector('#Details-menu-drawer-container');
    this.summary = this.mainDetails?.querySelector(':scope > summary');
    this.headerSection = document.querySelector('.section-header');
    this.closeFallbackTimer = null;

    this.bindAccordion();
    this.bindSearch();
    this.bindClose();
    this.bindDrawerLifecycle();
  }

  bindDrawerLifecycle() {
    if (!this.mainDetails) return;

    this.mainDetails.addEventListener('toggle', () => {
      if (this.mainDetails.hasAttribute('open')) {
        this.onMenuOpened();
      } else {
        this.onMenuFullyClosed();
      }
    });
  }

  onMenuOpened() {
    window.clearTimeout(this.closeFallbackTimer);
    this.summary?.setAttribute('aria-expanded', 'true');
  }

  onMenuFullyClosed() {
    window.clearTimeout(this.closeFallbackTimer);
    this.summary?.setAttribute('aria-expanded', 'false');
    this.mainDetails?.classList.remove('menu-opening');
    this.headerSection?.classList.remove('menu-open');
    this.resetAccordions();
    this.clearBodyScrollLock();
  }

  resetAccordions() {
    this.drawer.querySelectorAll('details.whoopea-accordion').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('is-active');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    });
  }

  clearBodyScrollLock() {
    ['overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop', 'overflow-hidden'].forEach(
      (className) => {
        document.body.classList.remove(className);
      }
    );
  }

  bindAccordion() {
    this.drawer.querySelectorAll('details.whoopea-accordion summary').forEach((summary) => {
      summary.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopPropagation();

          const details = summary.closest('details.whoopea-accordion');
          const willOpen = !details.hasAttribute('open');

          this.drawer.querySelectorAll('details.whoopea-accordion[open]').forEach((openDetails) => {
            if (openDetails !== details) {
              openDetails.removeAttribute('open');
              openDetails.classList.remove('is-active');
              openDetails.querySelector('summary')?.setAttribute('aria-expanded', 'false');
            }
          });

          if (willOpen) {
            details.setAttribute('open', '');
            details.classList.add('is-active');
            summary.setAttribute('aria-expanded', 'true');
          } else {
            details.removeAttribute('open');
            details.classList.remove('is-active');
            summary.setAttribute('aria-expanded', 'false');
          }
        },
        true
      );
    });
  }

  bindSearch() {
    this.drawer.querySelectorAll('.whoopea-menu-drawer .header__search summary').forEach((summary) => {
      summary.addEventListener(
        'click',
        (event) => {
          event.stopPropagation();
        },
        true
      );
    });
  }

  bindClose() {
    this.drawer.querySelectorAll('[data-whoopea-menu-close]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.closeDrawer();
      });
    });

    this.drawer.querySelector('[data-whoopea-cart-trigger]')?.addEventListener('click', (event) => {
      event.preventDefault();
      const cartDrawer = document.querySelector('cart-drawer');
      const trigger = this.drawer.querySelector('[data-whoopea-cart-trigger]');
      if (cartDrawer && trigger) cartDrawer.open(trigger);
    });

    this.summary?.addEventListener(
      'click',
      () => {
        if (!this.mainDetails?.hasAttribute('open')) return;

        this.summary.setAttribute('aria-expanded', 'false');
        this.mainDetails.classList.remove('menu-opening');
        this.headerSection?.classList.remove('menu-open');
        this.resetAccordions();
        this.scheduleCloseCleanup();
      },
      true
    );
  }

  closeDrawer() {
    if (!this.mainDetails?.hasAttribute('open')) return;

    this.summary?.setAttribute('aria-expanded', 'false');
    this.mainDetails.classList.remove('menu-opening');
    this.headerSection?.classList.remove('menu-open');
    this.resetAccordions();

    if (typeof this.drawer.closeMenuDrawer === 'function') {
      this.drawer.closeMenuDrawer(new Event('click'), this.summary);
    } else {
      this.mainDetails.removeAttribute('open');
      this.onMenuFullyClosed();
      return;
    }

    this.scheduleCloseCleanup();
  }

  scheduleCloseCleanup() {
    window.clearTimeout(this.closeFallbackTimer);

    // Dawn removes [open] after ~400ms animation — ensure overlay/state never sticks
    this.closeFallbackTimer = window.setTimeout(() => {
      if (this.mainDetails?.hasAttribute('open')) {
        this.mainDetails.removeAttribute('open');
      }
      this.onMenuFullyClosed();
    }, 450);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new WhoopeaMobileMenu();
});
